import React from 'react';

export const Blade89 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__blade89" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__blade89b">
        <use xlinkHref="#prefix__blade89" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__blade89b)"
        fill="#fff"
        stroke="#233762"
        strokeWidth={4.853}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path d="M49.5 120l-63.4-6.1V82l81.5 7.3z" />
        <path
          d="M45.7 94.7l-54.2-5.2c-3.1-.3-5.4-2.9-5.4-6V63.6c0-3.5 3-6.3 6.5-6l65.5 5.8c4.4.4 6.9 5.2 4.6 9L51.5 91.7c-1.2 2-3.5 3.2-5.8 3z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.7 69.7l-54.2-5.2c-3.1-.3-5.4-2.9-5.4-6V38.6c0-3.5 3-6.3 6.5-6l65.5 5.8c4.4.4 6.9 5.2 4.6 9L51.5 66.7c-1.2 2-3.5 3.2-5.8 3z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.7 44.7l-54.2-5.2c-3.1-.3-5.4-2.9-5.4-6V13.6c0-3.5 3-6.3 6.5-6l65.5 5.8c4.4.4 6.9 5.2 4.6 9L51.5 41.7c-1.2 2-3.5 3.2-5.8 3z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
